import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  FormControl,
  FormLabel,
  useClipboard,
  Flex,
  useToast,
  Select,
  Checkbox,
  Stack,
} from "@chakra-ui/react";
import AssessmentDataService from "../../services/Assessment";
import { SuggestedExperts } from "../../Config/AddAssessmentOptions";
import ExpertDataService from "../../services/Expert";

import {
  getCurrentTime,
  updatePaymentLinkHistory,
} from "../../Config/functions";

export const SendPaymentLinkModal = ({
  isOpen,
  onClose,
  data,
  row,
  id,
  func,
}: any) => {
  const token = localStorage.getItem("logged_in_user_token");
  const toast = useToast();
  const navigate = useNavigate();
  const { onCopy, value, setValue, hasCopied } = useClipboard("");
  const [amount, setAmount] = useState("");
  const [link, setLink] = useState("");
  const [expertName, setExpertName] = useState("");
  const [bookingType, setBookingType] = useState("");
  const [sessionType, setSessionType] = useState("");
  const [isLink, setIsLink] = useState(false);

  const [expertList, setExpertList] = useState<any>([]);

  // const [customer, setCustomer] = useState({
  //   name: "",
  //   contact: "",
  //   email: "",
  // });

  const [notify, setNotify] = useState({
    email: false,
    sms: false,
  });

  const [expertInformation, setExpertInformation] = useState({
    uuid: "",
    full_name: "",
    role: "",
  });

  const options = expertList.map((el: any) => ({
    value: el._id,
    label: el.data.full_name,
  }));

  const handleGenerateLink = () => {
    if (
      amount !== "" &&
      !isNaN(Number(amount)) &&
      expertInformation.full_name !== ""
    ) {
      const obj: any = {
        amount: amount,
        customer: {
          name: data.name,
          contact: data.phone,
          email: data.email,
        },
        description: `RPL_${sessionType}_${bookingType}_SESSION_WITH_${expertInformation.full_name}_${expertInformation.uuid}`,
        notify: notify,
      };

      AssessmentDataService.getBasicPaymentLink(obj, token)
        .then((res) => {
          setIsLink(true);
          setLink(res.data);
          setValue(res.data);
        })
        .catch((e) => {
          const response = e.response.data;
          toast({
            position: "top",
            title: "Error Generating Link.",
            description: response.message,
            status: "error",
            duration: 1000,
            isClosable: true,
          });
        });
    } else {
      toast({
        position: "top",
        title: "Enter Valid Amount",
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    }
  };

  const fetchExperts = async () => {
    try {
      const expertRes = await ExpertDataService.getExperts(token);
      setExpertList(expertRes.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleExpertDetails = (value: any) => {
    const data = expertList.find((el: any) => el._id === value);
    if (data) {
      setExpertInformation({
        ...expertInformation,
        uuid: value,
        full_name: data.data.full_name,
        role: data.data.role,
      });
    } else {
      setExpertInformation({
        uuid: "",
        full_name: "",
        role: "",
      });
    }
  };

  const handleSendMessage = () => {
    if (link === "") {
      toast({
        position: "top",
        title: "Link is not generated",
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    } else {
      const clientData: any = [
        {
          phone_number: "91" + data.phone,
          name: data.name,
          dynamic_data: {
            key1: value,
          },
        },
      ];
      const expertObj = SuggestedExperts.find(
        (el: any) => el.value === expertName
      ) || { label: "" };
      const expert = expertObj.label;
      const linkObj = {
        date: getCurrentTime(),
        expert: expert,
        amount: amount,
        link: link,
      };
      const templateName = "payment_link";
      const message = {
        type: "Payment Link",
        date: getCurrentTime(),
        template: templateName,
      };
      const updatedData: any = updatePaymentLinkHistory(row, linkObj, message);
      AssessmentDataService.sendMessage(
        {
          templateName: templateName,
          clientdata: clientData,
        },
        token
      )
        .then((res) => {
          setValue("");
          setLink("");
          setIsLink(false);
          AssessmentDataService.update(updatedData, id, token).then(
            (res: any) => {
              func(message, linkObj);
            }
          );
          closeModal();
        })
        .catch((e: Error) => {
          closeModal();
          console.log(e);
        });
    }
  };

  const closeModal = () => {
    setSessionType("");
    setBookingType("");
    setExpertName("");
    setLink("");
    setAmount("");
    onClose();
  };

  useEffect(() => {
    setIsLink(false);
    fetchExperts();
  }, []);

  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send Payment Link</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={6}>
            <FormLabel>Amount (in Rs)</FormLabel>
            <Input
              placeholder="Enter Amount"
              onChange={(e) => setAmount(e.target.value)}
            />
          </FormControl>
          <Flex>
            <FormControl pr={2} mb={8}>
              <FormLabel>Select Expert</FormLabel>
              <ReactSelect
                id="expert"
                name="expert"
                options={options}
                placeholder="Choose Expert"
                isClearable
                value={options.find(
                  (option: any) => option.value === expertInformation.uuid
                )}
                onChange={(option) =>
                  handleExpertDetails(option ? option.value : null)
                }
                classNamePrefix="react-select"
              />
            </FormControl>
          </Flex>
          <Flex mb={8}>
            <FormControl pr={2}>
              <FormLabel>Select Booking Type</FormLabel>
              <Select
                value={bookingType}
                onChange={(e: any) => setBookingType(e.target.value)}
              >
                <option value="">Select</option>
                <option value="SINGLE">Single</option>
                <option value="SUBSCRIPTION3">Subscription 3</option>
                <option value="SUBSCRIPTION5">Subscription 5</option>
                <option value="SUBSCRIPTION10">Subscription 10</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>Select Session Type</FormLabel>
              <Select
                value={sessionType}
                onChange={(e: any) => setSessionType(e.target.value)}
              >
                <option value="">Select</option>
                <option value="inperson">In-person</option>
                <option value="video">Video</option>
                <option value="call">Call</option>
                <option value="chat">Chat</option>
              </Select>
            </FormControl>
          </Flex>
          <Flex>
            <FormControl>
              <FormLabel>Notify</FormLabel>
              <Stack spacing={2}>
                <Checkbox
                  onChange={(e) =>
                    setNotify((prev) => ({
                      ...prev,
                      email: e.target.checked,
                    }))
                  }
                >
                  Noitfy Via Email
                </Checkbox>
                <Checkbox
                  onChange={(e) =>
                    setNotify((prev) => ({ ...prev, sms: e.target.checked }))
                  }
                >
                  Noitfy Via SMS
                </Checkbox>
              </Stack>
            </FormControl>
          </Flex>

          {isLink && (
            <Flex mt={5} mb={2}>
              <Input value={value} mr={2} />
              <Button onClick={onCopy}>{hasCopied ? "Copied!" : "Copy"}</Button>
            </Flex>
          )}
        </ModalBody>

        <ModalFooter>
          <Flex justifyContent={"space-between"}>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={10}
              onClick={handleGenerateLink}
            >
              Generate Link
            </Button>
            <Button
              bgColor="#F48A0F"
              color={"white"}
              mr={3}
              onClick={handleSendMessage}
            >
              Send Message
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
